import React from "react";
import Icon from "sulu-admin-bundle/components/Icon";
import EventIcons from "./EventIcons";

const GoalDetails = ({ eventDetails }) => {
  return (
    <>
      <div
        style={{
          width: "10%",
          display: "flex",
          alignItems: "center",
        }}
      >
          {eventDetails?.penaltyShoot ?
              <p>Penalty</p> :
              <>
                  <EventIcons
                      icon={
                          <Icon
                              name="su-align"
                              style={{
                                  color: "white",
                              }}
                          />
                      }
                  />
                  <p
                      style={{
                          fontWeight: "700",
                      }}
                  >
                    {eventDetails?.typeOfPsGoalSelected ? (eventDetails?.typeOfPsGoalSelected?.name == 'Miss' ? 'Miss' : '') : ''}
                      {((eventDetails?.typeOfGoal?.id !== 16 && eventDetails?.typeOfGoal?.id !== 28) && !eventDetails?.typeOfPsGoalSelected) ? `${eventDetails?.home?.goals} : ${eventDetails?.away?.goals}` : '' }
                  </p>
              </>
          }
      </div>
      <div
        style={{
          width: "35%",
        }}
      >
        <span
          style={{
            marginRight: 5,
          }}
        >
            {!eventDetails?.typeOfPsGoalSelected && eventDetails?.playerSelected?.playerNumber}
            {eventDetails?.penaltyShootGoal ? 'Goal' : null}
            {eventDetails?.penaltyShootMiss ? 'Miss' : null}
        </span>
        <span style={{}}>{!eventDetails?.typeOfPsGoalSelected && eventDetails?.playerSelected?.playerName}</span>
      </div>
      <div
        style={{
          width: "15%",
        }}
      >
        <span style={{}}>{eventDetails?.sideSelected?.teamName}</span>
      </div>
    </>
  );
};

export default GoalDetails;
